import React, { useState } from 'react';
import { Box, Paper, List, ListItem, ListItemText, TextField, Button, Avatar, Stack } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const Chat = ({ messages, getMessages, addMessage }) => {
    // const [messages, setMessages] = useState([
    //     { id: 1, text: 'Hello! How are you?', sender: 'User1' },
    //     { id: 2, text: 'I am doing great, thanks!', sender: 'User2' },
    // ]);
    const [input, setInput] = useState('');
    // const [messages, setMessages] = useState(getMessages());

    const handleSend = () => {
        if (input.trim()) {
            // addMessage({id: Date.now(), text: input, sender: 'User1'})
            addMessage(input);
        //     const newMessages = [...messages, { id: Date.now(), text: input, sender: 'User1' }];
        //     setMessages(newMessages);
            setInput('');
        }
    };

    return (
        // <Paper elevation={0} sx={{ height: 400, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Message List Area */}
            <Box sx={{ flexGrow: 1, overflowY: 'auto', padding: 2 }}>
                <List>
                    { messages.map((message) => (
                        <ListItem
                            key={message.id}
                            sx={{ justifyContent: message.sender === 'User1' ? 'flex-end' : 'flex-start' }}
                        >
                            <Stack direction="row" spacing={1} alignItems="center">
                                {message.sender !== 'User1' && <Avatar>U2</Avatar>}
                                <Box
                                    sx={{
                                        padding: 1.5,
                                        borderRadius: '20px',
                                        bgcolor: message.sender === 'User1' ? 'primary.main' : 'grey.300',
                                        color: message.sender === 'User1' ? 'white' : 'black',
                                        maxWidth: '70%',
                                        wordWrap: 'break-word',
                                    }}
                                >
                                    <ListItemText primary={message.text} />
                                </Box>
                                {message.sender === 'User1' && <Avatar>U1</Avatar>}
                            </Stack>
                        </ListItem>
                    ))}
                </List>
            </Box>

            {/* Input Area */}
            <Box sx={{
                position: 'fixed',
                width: '100%',
                bottom: 0,
                m: 0,
                p: 1,
            }}>
                <Stack direction="row" spacing={2} sx={{justifyContent: 'center', alignItems: 'center'}}>
                    <Box>
                    <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="Сообщение"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleSend()}
                    />
                    </Box>
                    <Box>
                        <SendIcon
                            fontSize={"large"}
                            onClick={handleSend}
                        ></SendIcon>
                    </Box>
                    {/*<Button variant="contained" color="primary" onClick={handleSend}>*/}
                    {/*    Send*/}
                    {/*</Button>*/}
                </Stack>
            </Box>
    </Box>
        // </Paper>
    );
};

export default Chat;

